<template>
    <v-card-text>
        <v-container fluid>
            <v-row dense>
                <v-col cols="12" sm="12">

                    <v-row dense>
                        <v-col cols="12">
                            <span color="black" class="headline text-xs-center" v-text="'Datos Póliza'"></span>
                        </v-col>
                    </v-row>

                    <v-row dense>
                        <v-col cols="12" sm="4">
                            <v-text-field label="Contratante" color="textbox" v-model="obModal.contratante"
                                 readonly outlined dense />
                        </v-col>
                        <v-col cols="12" sm="4">
                            <v-text-field label="Aseguradora" color="textbox" v-model="obModal.aseguradora"
                                 readonly outlined dense />
                        </v-col>
                        <v-col cols="12" sm="4">
                            <v-text-field label="Seguro" color="textbox" v-model="obModal.seguro"
                                 readonly outlined dense />
                        </v-col>
                    </v-row>

                    <v-row dense>
                        <v-col cols="12" sm="4">
                            <v-text-field label="Naturaleza" color="textbox" v-model="obModal.naturaleza"
                                 readonly outlined dense />
                        </v-col>
                        <v-col cols="12" sm="4">
                            <v-text-field label="Regulación" color="textbox" v-model="obModal.regulacion"
                                 readonly outlined dense />
                        </v-col>
                        <v-col cols="12" sm="4"></v-col>
                    </v-row>

                    <v-row dense>
                        <v-col cols="12" sm="3">
                            <v-text-field label="Canal" color="textbox" v-model="obModal.canal"
                                 readonly outlined dense />
                        </v-col>
                        <v-col cols="12" sm="3">
                            <v-text-field label="Tipo Póliza" color="textbox" v-model="obModal.tipoPoliza"
                                 readonly outlined dense />
                        </v-col>
                        <v-col cols="12" sm="3">
                            <v-text-field label="Número Póliza" color="textbox" v-model="obModal.poliza"
                                 readonly outlined dense />
                        </v-col>
                        <v-col cols="12" sm="3">
                            <v-text-field label="Comisión %" color="textbox" v-model="obModal.porcComision"
                                 readonly outlined dense />
                        </v-col>
                    </v-row>

                    <v-row dense>
                        <v-col cols="12" sm="4">
                            <v-text-field label="Beneficio" color="textbox" v-model="obModal.porcBeneficios"
                                 readonly outlined dense />
                        </v-col>
                        <v-col cols="12" sm="4">
                            <v-text-field label="Provincia" color="textbox" v-model="obModal.provincia"
                                 readonly outlined dense />
                        </v-col>
                        <v-col cols="12" sm="4">
                            <v-text-field label="Cantón" color="textbox" v-model="obModal.canton"
                                 readonly outlined dense />
                        </v-col>
                    </v-row>

                    <v-row dense>
                        <v-col cols="12" sm="4">
                            <v-text-field label="Fecha Desde" color="textbox" v-model="obModal.fechaDesde"
                                 readonly outlined dense prepend-inner-icon="event"/>
                        </v-col>
                        <v-col cols="12" sm="4">
                            <v-text-field label="Fecha Hasta" color="textbox" v-model="obModal.fechaHasta"
                                 readonly outlined dense prepend-inner-icon="event"/>
                        </v-col>
                        <v-col cols="12" sm="4">
                            <v-text-field label="Fecha Emisión" color="textbox" v-model="obModal.fechaEmision"
                                 readonly outlined dense prepend-inner-icon="event"/>
                        </v-col>
                    </v-row>

                    <v-row dense>
                        <v-col cols="12" sm="6">
                            <v-text-field label="Broker" color="textbox" v-model="obModal.broker"
                                 readonly outlined dense />
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-text-field label="Estado" color="textbox" v-model="obModal.estado"
                                 readonly outlined dense />
                        </v-col>
                    </v-row>

                    <v-row dense class="mt-3 mb-3" align="center" justify="center">
                        <v-col cols="12" class="text-center">
                            <v-icon color="secundary" class="btnNext" @click="siguiente">arrow_forward</v-icon>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-container>
    </v-card-text>
</template>

<script>
    export default {
        name: 'windowDatosPolizaComponent',
        inject:['siguiente'],
        props: {
            listGeneral: {
                type: Object,
                default: {}
            },
            obModal: {
                type: Object,
                default: {}
            }
        }
    }
</script>
